export default __webpack_public_path__ + "static/media/DE4.4eb277eb.svg";